<ng-container *ngIf="cart">
  <form [formGroup]="form" class="cx-saved-cart-form-container">
  <div class="modal-restore-saved-cart modal-fade">
    <div class="header">
      <div class="headline"><span class="headline-text">Recuperar carrito guardado </span></div>
      <button
        class="glyphicon glyphicon-remove cancel"
        (click)="close('Close Restore Cart Dialog')"
        onkeydown="this.blur()"
        tabIndex="0"
      ></button>
    </div>
    <div class="content">
      <p>El carrito guardado reemplazará su carrito actual</p>
      <div class="modal-details row">
        <span class="col-6">Nombre del carrito:</span>
        <span class="col-6"
          ><b>{{ cart.name }}</b></span
        >
        <span class="col-6">Código del carrito:</span>
        <span class="col-6"
          ><b>{{ cart.code }}</b></span
        >
        <span class="col-6">Cantidad de productos:</span>
        <span class="col-6"
          ><b> {{ cart.totalUnitCount }} </b></span
        >
      </div>

      <input
        type="checkbox"
        id="keepRestoredCart"
        name="keepRestoredCart"
        checked="checked"
        [checked]="isCloneSavedCart"
        (change)="customToggleIsCloneSavedCart()"
      />
      <label for="keepRestoredCart"> Mantener una copia de este carrito </label>

      <div class="modal-details-restore">
        <ng-container *ngIf="(currentCart$ | async)">
          <div class="form-group">
            <p>Los productos en el carrito se guardarán como:</p>
            <input
              type="text"
              id="activeCartName"
              name="activeCartName"
              formControlName="cloneName"
              class="text form-control"
              [value]="cart.code"
              maxlength="255"
            />
            <input type="checkbox" id="preventSaveActiveCart" name="preventSaveActiveCart" formControlName="preventSaveActiveCart" />
            <label for="preventSaveActiveCart"> Quieres guardar tus productos?</label>
          </div>
        </ng-container>
      </div>

      <div class="modal-actions">
        <div class="row">
          <div class="col-12 col-sm-6 col-sm-pull-6">
            <button (click)="close('Close Restore Cart Dialog')" type="button" class="btn btn-default btn-block">
              Cancelar
            </button>
          </div>
          <div class="col-12 col-sm-6 col-sm-push-6">
            <button type="button" class="btn btn-primary btn-block" (click)="restoreSavedCart(cart.code)">
              Recuperar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </form>
</ng-container>
